import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import history from "../../managers/history";
import { uiConstant, keyConstants } from "../../constants";
import { useSelector, useDispatch } from "react-redux";
import Utils from "../../utility";
import RewardsService from "../../services/reward";
import { mobileSideBar, removeUser, updateUser } from "../../slices/userSlice";
const { sideBarPath } = uiConstant;

const Sidebar = () => {
  const [rewardExpanded, setRewardExpanded] = useState(false);
  const location = useLocation();
  const pathArray = location.pathname.split("/").slice(0, 3);
  const pathName = pathArray.join("/");
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const { IS_REFRESH_TOKEN_LOADING } = keyConstants;

  useEffect(() => {
    if (
      !pathName.startsWith("/consent/consent-reward") &&
      !pathName.startsWith("/consent/consent-coupon") &&
      !pathName.startsWith("/consent/consent-allocation") &&
      !pathName.startsWith("/consent/consent-email")
    ) {
      setRewardExpanded(false);
    }
  }, [pathName]);

  useEffect(() => {
    const fetchData = async () => {
      const tokenStatus = await Utils.checkTokenExpireOrNot(fetchData);
      if (tokenStatus) {
        if (tokenStatus === IS_REFRESH_TOKEN_LOADING) return;
        dispatch(removeUser({}));
        return;
      }
      // Step 1: Retrieve the business ID from the redux user state
      const businessId = user?._id;

      // Step 2: Call the getRewardByBusinessId function to get the reward ID
      const [error, getRewardRes] = await Utils.parseResponse(
        new RewardsService().getRewardByBusinessId(businessId)
      );

      // Step 3: Check if the reward id is available
      if (getRewardRes && Object.keys(getRewardRes).length > 0) {
        dispatch(
          updateUser({
            ...user,
            rewardId: getRewardRes?._id || "",
            rewardStatus:
              getRewardRes?.isConsentsEnabled ||
              getRewardRes?.isEmailDiscountEnabled
          })
        );
      } else if (error) {
        dispatch(
          updateUser({
            ...user,
            rewardId: getRewardRes?._id || ""
          })
        );
      }
    };
    if (user?._id) {
      fetchData();
    }
  }, [user?._id]);

  useEffect(() => {
    // Check if the current path is a reward sub-route
    if (
      pathName.startsWith("/consent/consent-reward") ||
      pathName.startsWith("/consent/consent-coupon") ||
      pathName.startsWith("/consent/consent-allocation") ||
      pathName.startsWith("/consent/consent-email")
    ) {
      setRewardExpanded(true);
    } else {
      setRewardExpanded(false);
    }
  }, [pathName]);

  const handleItemClick = (clickedPath) => {
    dispatch(mobileSideBar(false));
    if (
      clickedPath.startsWith("/consent/consent-reward") ||
      clickedPath.startsWith("/consent/consent-coupon") ||
      clickedPath.startsWith("/consent/consent-allocation") ||
      clickedPath.startsWith("/consent/consent-email")
    ) {
      history.push(clickedPath);
      setRewardExpanded(true);
    } else {
      history.push(clickedPath);
      setRewardExpanded(false);
    }
  };

  const handleChildClick = (path) => {
    dispatch(mobileSideBar(false));
    history.push(path);
  };
  return (
    <div
      className={`${
        user?.isMobileSidebar ? "absolute z-10 bg-white" : "hidden md:block"
      } h-full min-w-69 border-r border-grey-E3E3E3 px-2 md:min-w-60 md:px-11px`}
    >
      <div className="sticky top-0 flex w-full flex-col gap-2 pt-4 md:gap-6 md:pt-73px">
        {sideBarPath.map((data) => (
          <React.Fragment key={data?.name.toLocaleLowerCase()}>
            <div
              onClick={() => handleItemClick(data?.pathname)}
              className={`${
                data?.selectedPathNames.includes(pathName)
                  ? "bg-purple-F6E6FB text-purple-6C36B0"
                  : ""
              } flex cursor-pointer items-center gap-3.5  rounded-lg 
                 pt-11px pb-10.72px
               pl-4.5`}
            >
              <img
                className={`${
                  data?.selectedPathNames.includes(pathName)
                    ? "filter-darkPurple-10"
                    : ""
                }`}
                src={data.img}
                alt="icon"
              />
              <div className="font-MontserratMedium text-ft15">
                {data?.name === "Rewards" ? (
                  <>
                    {data.name}{" "}
                    <span
                      className={`${user?.rewardId && user?.rewardStatus ? "border-purple-E2B6FF bg-purple-6C36B0 text-white" : "border-grey-DBDBDB bg-white text-grey-767676"} ml-12.5 inline-block w-8.5 rounded border  text-center font-MontserratMedium text-ft12-16 font-medium`}
                    >
                      {user?.rewardId && user?.rewardStatus ? "On" : "Off"}
                    </span>
                  </>
                ) : (
                  data.name
                )}
              </div>
            </div>
            {data?.name === "Rewards" && rewardExpanded && (
              <div className="flex flex-col gap-2">
                <div
                  onClick={() => handleChildClick("/consent/consent-coupon")}
                  className={`${
                    pathName === "/consent/consent-coupon"
                      ? "bg-purple-F6E6FB text-purple-6C36B0"
                      : ""
                  } flex cursor-pointer items-center gap-3.5 rounded-lg pb-10.72px pl-4.5 pt-11px`}
                >
                  <img
                    src="/images/subheading.svg"
                    alt="subheading"
                    className="ml-7px mr-2"
                  />
                  <div className="font-MontserratMedium text-ft15">
                    Coupons Inventory
                  </div>
                </div>
                <div
                  onClick={() =>
                    handleChildClick("/consent/consent-allocation")
                  }
                  className={`${
                    pathName === "/consent/consent-allocation"
                      ? "bg-purple-F6E6FB text-purple-6C36B0"
                      : ""
                  } flex cursor-pointer items-center gap-3.5  rounded-lg pb-10.72px pl-4.5 pt-11px`}
                >
                  <img
                    src="/images/subheading.svg"
                    alt="subheading"
                    className="ml-7px mr-2"
                  />
                  <div className="font-MontserratMedium text-ft15">
                    Coupons Allocation
                  </div>
                </div>
                <div
                  onClick={() => handleChildClick("/consent/consent-email")}
                  className={`${
                    pathName === "/consent/consent-email"
                      ? "bg-purple-F6E6FB text-purple-6C36B0"
                      : ""
                  } flex cursor-pointer items-center gap-3.5  rounded-lg pb-10.72px pl-4.5 pt-11px`}
                >
                  <img
                    src="/images/subheading.svg"
                    alt="subheading"
                    className="ml-7px mr-2"
                  />
                  <div className="font-MontserratMedium text-ft15">
                    Email Database
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
